import {Injectable} from '@angular/core';


@Injectable()
export class DashboardService {

  customTicks = {
    min: 0,
    beginAtZero: true,
    // fontSize: 13,
    callback: (val) => {
      if (!val || +val < 1) {
        return val;
      }
      const units = ['', ' K', ' M', ' B'];
      const k = 1000;
      const magnitude = Math.floor(Math.log(val) / Math.log(k));
      const value = val / Math.pow(k, magnitude);
      let finalValue = value.toString();
      if (value.toString().length === 1) {
        finalValue = value.toFixed(1).toString();
      }
      return (
        finalValue + units[magnitude]
      );
    },
  };

  customTicks2 = {
    min: 0,
    beginAtZero: true,
    callback: (val) => {
      // console.log(val);
      if (!val || isNaN(+val) || +val < 1) {
        return val;
      }
      const units = ['', ' K', ' M', ' B'];
      const k = 1000;
      const magnitude = Math.floor(Math.log(val) / Math.log(k));
      const value = val / Math.pow(k, magnitude);
      let finalValue = value.toString();
      if (value.toString().length === 1) {
        finalValue = value.toFixed(1).toString();
      }
      // console.log(finalValue + units[magnitude]);
      return (
        finalValue + units[magnitude]
      );
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/dashboards/dashboard.service.ts